function loadSlickSlider(param) {
    //  Slick parameter: dots, initialCallback, beforeChangeCallback, afterChangeCallback, breakpointCallback, prevArrowSelector, nextArrowSelector, imageoffset, autoplaySpeed, autoplay,  pauseOnHover, variableWidth, slidesToShow, and more
    //  additional parameters: sliderIdClass, popupLinkClass, ondemandPlus2, imageoffset (unused), responsive_3_SlideSlider, circularSlider, announceSlidesShown, mouseWheelScrolling

    param = $.extend(
        {
            dots: false, // Slick standard parameters, our default settings used if not specified in loadSlickSlider
            autoplaySpeed: 3000,
            lazyLoad: 'ondemand',
            infinite: true,
            focusOnSelect: false,
            fade: false,
            prevArrow: param.prevArrowSelector,
            nextArrow: param.nextArrowSelector,
            focusOnChange: false,
            autoplay: false,

            ondemandPlus2: true, // Our customizations, defaults
            imageoffset: 0,
            responsive_3_SlideSlider: false,
            circularSlider: true,
            announceSlidesShownFor: null,
            mouseWheelScrolling: false,
            disablePopupCaptions: false,
            slideAnimation: false,

            galleryCustomMarkup: null,
            popupOnChangeCallback: null,
        },
        param,
    );

    var returnedSlider = null;
    var slickSlider = '.' + param.sliderIdClass;
    var $slickSlider = $(slickSlider);

    if ($(slickSlider + '.slick-initialized').length) {
        // must have already been initialized, so destroy and start anew
        $(slickSlider).slick('unslick');
    }

    if (!!param.popupLinkClass) {
        var mPopupOptions = {
            type: 'image',
            gallery: {
                enabled: true,
            },
            callbacks: {
                open: function () {
                    $('iframe').css({ visibility: 'hidden' });
                    if ($('.mfp-counter').html().length === 0) {
                        // if there is no text in this element, the scroller must contain just a
                        // single photo.  add class to eliminate reserved space not needed from absent "1 of 1" text
                        $('.mfp-title').addClass('single-photo-gallery');
                        $('.mfp-img').addClass('mfp-default-cursor');
                    }
                },
                close: function () {
                    $('iframe').css({ visibility: 'visible' });
                },
            },
        };
        if (!!param.popupOnChangeCallback) {
            mPopupOptions.callbacks.change = function () {
                const popup = this;
                param.popupOnChangeCallback(popup);
            };
        }
        if (param.disablePopupCaptions) {
            mPopupOptions.image = { titleSrc: null };
        }
        if (!!param.galleryCustomMarkup) {
            if (!!mPopupOptions.image) {
                mPopupOptions.image.markup = param.galleryCustomMarkup;
            } else {
                mPopupOptions.image = { markup: param.galleryCustomMarkup };
            }
        }

        $slickSlider.find('.' + param.popupLinkClass).magnificPopup(mPopupOptions);
    }

    // handle the case where there are fewer slides than what is possible to display. Set scroller width so that slides are centered, while allowing slick to toggle display of arrows and dots as needed.  To work, slick parameter variableWidth must be true, while the actual slides must all be of consistent width.
    function setSlickSliderSize(slick) {
        var oneSlideWidth = $slickSlider.find('.slick-slide').width(); // slides must be of a consistent width
        var slideMargins = $slickSlider.find('.slick-slide').outerWidth(true) - oneSlideWidth;
        var widthFor_2_Slides = 2 * oneSlideWidth + 2 * slideMargins - 1;
        var widthFor_3_Slides = 3 * oneSlideWidth + 3 * slideMargins - 1;
        var totalNumSlides = slick.slideCount;

        $slickSlider.removeAttr('style'); // removes any previously set width from last time through
        var sliderWidth = $slickSlider.width();
        if (totalNumSlides > 2 && widthFor_3_Slides <= sliderWidth) {
            $slickSlider.width(widthFor_3_Slides);
        } else if (totalNumSlides > 1 && widthFor_2_Slides <= sliderWidth) {
            $slickSlider.width(widthFor_2_Slides);
        } else {
            $slickSlider.width(oneSlideWidth + slideMargins);
        }
    }

    function removeAriaDescribedbyIfBad(slickSliderName) {
        // Helper function removes aria-labelledby references that point to removed elements, since Slick removes tablist elements when all slides can be shown and no scrolling is necessary
        $(slickSliderName + ' .slick-slide[aria-describedby]').each(function () {
            if (!document.getElementById($(this).attr('aria-describedby'))) {
                // If the element no longer exists
                // remove the reference to it.
                $(this).removeAttr('aria-describedby');
            }
        });
    }

    function scrollerKeyHandler(event, slickSlider) {
        // Attaches key handler to fully support standard tablist keyboard patterns (adding home key and end key press actions)
        // but also support special handling that makes scroller appear there are no slides to right of last slide and no slides to left of first slides
        var keycode = event.keyCode ? event.keyCode : event.which;
        var activeElementIsADot = $(document.activeElement).attr('role') === 'tab';
        var focusedElementSelector = '';
        if ($(slickSlider + ' .slick-slide.slick-active').find(':focus').length === 1) {
            // if focus on an element within the slide (e.g. the expand icon), after we use keys to slide the scroller, we want to reset focus on the same element within the new slide
            focusedElementSelector = document.activeElement.className
                ? '.' + document.activeElement.className.replace(/\s+/g, ' .')
                : '';
        }
        var currentSlide;
        switch (
            keycode // this special key and arrow handling were required because it is different than either of the standard two options that slickSlider provides.
        ) {
            case 36: // home key pressed, move slider into first position
                $slickSlider[0].slick.goTo(0, false);
                break;

            case 35: //  end key pressed, move slider into the rightmost desired position.
                slideScrollerToLastPosition();
                break;

            case 37: // left arrow key pressed, if pressed while on the Wistia playbar, then bump back the video 2 secs
                if ($(event.target).attr('aria-label') == 'Playbar') {
                    var wistiaPlayerId = $(event.target).closest('.wistiaVideoPlayer').attr('id');
                    if (wistiaPlayerId) {
                        var video = Wistia.api(wistiaPlayerId);
                        video.time(video.time() - 2);
                    }
                    event.stopPropagation();
                    break;
                } else {
                    currentSlide = $slickSlider[0].slick.currentSlide; // left arrow key pressed, if pressed while on first slide position, then roll the slider to the last position.
                    if (currentSlide === 0) {
                        slideScrollerToLastPosition();
                    } else {
                        $slickSlider[0].slick.goTo(currentSlide - 1, false);
                    }
                    break;
                }

            case 39: //  right arrow key pressed, if pressed while on the the Wistia playbar, then forward the video 2 secs
                if ($(event.target).attr('aria-label') == 'Playbar') {
                    var wistiaPlayerId = $(event.target).closest('.wistiaVideoPlayer').attr('id');
                    if (wistiaPlayerId) {
                        var video = Wistia.api(wistiaPlayerId);
                        video.time(video.time() + 2);
                    }
                    event.stopPropagation();
                    break;
                } else {
                    currentSlide = $slickSlider[0].slick.currentSlide; //  if right arrow key pressed while slide is the rightmost slider position, then roll the slider to the first position.
                    var slideCount = $slickSlider[0].slick.slideCount;
                    var slidesShowing = $(
                        slickSlider + " :not('.slick-dots') .slick-slide.slick-active:not('.slick-cloned')",
                    ).length;
                    if (currentSlide + slidesShowing >= slideCount) {
                        $slickSlider[0].slick.goTo(0, false);
                    } else {
                        $slickSlider[0].slick.goTo(currentSlide + 1, false);
                    }
                    break;
                }

            default:
                return true;
        }
        if (activeElementIsADot) {
            // if navigating using the keyboard in the dots, then move focus to the dot that you are navigating to
            setTimeout(function () {
                $slickSlider.find('li.slick-active button').focus();
            }, 500);
        } else if (focusedElementSelector) {
            setTimeout(function () {
                // if focus on an element within the slide (e.g. the expand icon), after we use keys to slide the scroller, we want to reset focus on the same element within the new slide
                $slickSlider.find('.slick-slide.slick-active ' + focusedElementSelector).focus();
            }, 1000);
        }
        event.preventDefault();
        return false;
    }

    function slideScrollerToLastPosition() {
        // slide the scroller rolling back to the "last" position, where last slide is in the rightmost visible slide position.
        var slidesShowing = $(
            slickSlider + " :not('.slick-dots') .slick-slide.slick-active:not('.slick-cloned')",
        ).length;
        $slickSlider[0].slick.goTo($slickSlider[0].slick.slideCount - slidesShowing, false);
    }

    $slickSlider.on('init', function (event, slick) {
        //	The init event handler must be bound before initializing the slick slider.
        if (!!param.initialCallback) {
            param.initialCallback(event, slick);
        }

        //  To avoid double rendering flash of the opening image, allow Slick to lazy load that photo.  Here we lazy load 2 slides to the right and 2 slides to the left of it
        //  The window must be centered on the slide we actually open on: sliders opened through initialSlide (a media scroller jump) otherwise never preload anything near it, leaving those slides blurred until they are visited.
        //  For "infinite" scrollers, Slick creates a second set of "cloned" slides.  For smooth scrolling, both the original and this cloned slide must be lazy loaded.

        if (param.lazyLoad === 'ondemand' && param.ondemandPlus2 && slick.slideCount > 0) {
            var slidesToLazyLoadArray = [-2, -1, 0, 1, 2].map(function (offset) {
                return (slick.currentSlide + offset + slick.slideCount) % slick.slideCount;
            });
            if (param.infinite) {
                var clonedSlides = [].concat(
                    slidesToLazyLoadArray.map(function (a) {
                        return a + slick.slideCount;
                    }),
                    ['-1'],
                );
                slidesToLazyLoadArray = [].concat(slidesToLazyLoadArray, clonedSlides);
            }
            slidesToLazyLoadArray.forEach(function (index) {
                var slideToLazyLoad = $(
                    slickSlider + ' .slick-slide[data-slick-index=' + index + '] img.slick-loading',
                );
                if (slideToLazyLoad.length > 0) {
                    var src = slideToLazyLoad.attr('src');
                    if (typeof src === 'undefined' || src === false) {
                        if (
                            slideToLazyLoad.hasClass('slider-full-image') ||
                            slideToLazyLoad.hasClass('object-fit-cover') ||
                            slideToLazyLoad.hasClass('object-fit-contain')
                        ) {
                            // do after-image-loaded actions when 1) swapping low res images out or 2) doing workaround of ie/edge non-support of object-fit: cover
                            slideToLazyLoad[0].addEventListener('load', slideImageLoaded);
                        }
                        slideToLazyLoad
                            .attr('src', slideToLazyLoad.attr('data-lazy'))
                            .removeClass('slick-loading')
                            .removeAttr('data-lazy');
                        // Cached images may complete before/without a load event.
                        if (slideToLazyLoad[0].complete && slideToLazyLoad[0].naturalWidth > 0) {
                            slideImageLoaded.call(slideToLazyLoad[0]);
                        }
                    }
                }
            });
        }
        if (param.responsive_3_SlideSlider) {
            setSlickSliderSize(slick);
            $(window).resize(function () {
                setSlickSliderSize(slick);
            });
            $(window).trigger('resize'); // have to trigger resize ourselves to force Slick to initialize fully
        }

        $(param.prevArrowSelector).click(function (event, slick) {
            // if scroller is in first position, and the prev arrow is clicked, slide right the scroller to the last position, which has the last slide in the rightmost visible position, rather than letting slickslider slide to the left in a circular wrapped method.
            if ($slickSlider[0].slick.currentSlide === 0) {
                slideScrollerToLastPosition(slick);
                event.preventDefault();
                return false;
            }
        });

        $(param.nextArrowSelector).click(function (event, slick) {
            // when the next arrow is clicked, and scroller is as far right as we want it to go (last slide is in the rightmost visible slide position), slide left the scroller to the first position rather than letting slickslider slide the scroller to the right in a circular scroller wrapped method.
            var slideCount = $slickSlider[0].slick.slideCount;
            var slidesShowing = $(slickSlider + " :not('.slick-dots') .slick-active:not('.slick-cloned')").length;
            if ($slickSlider[0].slick.currentSlide + slidesShowing >= slideCount) {
                $slickSlider[0].slick.goTo(0, false);
                event.preventDefault();
                return false;
            }
        });
        $(param.prevArrowSelector).keydown(function (event) {
            scrollerKeyHandler(event, slickSlider);
        }); // attach scroller key handler to the left arrow, right arrow
        $(param.nextArrowSelector).keydown(function (event) {
            scrollerKeyHandler(event, slickSlider);
        });
        $(slickSlider + ' .slick-slide:not(.slick-cloned)').keydown(function (event) {
            scrollerKeyHandler(event, slickSlider);
        }); // attach scroller key handler to all buttons on the slides (anywhere that that a keyboard may tab to)
        $(slickSlider + ' .slick-slide:not(.slick-cloned) button').keydown(function (event) {
            scrollerKeyHandler(event, slickSlider);
        });
        if (param.dots) {
            processDots(slick, slickSlider);
        }
        setTimeout(function () {
            // Need to disable/enable buttons and set tabindexs so that focus(and tabbing) cannot occur where aria-hidden=true (cloned Slick slides).  Such focusable buttons and divs are in Wistia video containers
            $slickSlider.find(".slick-slide[aria-hidden='true'] button").attr('disabled', 'disabled');
            $slickSlider.find(".slick-slide[aria-hidden='true'] [tabindex='0']").attr('tabindex', '-1');
            $slickSlider.find(".slick-slide:not(.slick-cloned)[aria-hidden='false'] button").removeAttr('disabled');
            $slickSlider
                .find(".slick-slide:not(.slick-cloned)[aria-hidden='false'] :not(.noTabStopHere)[tabindex='-1']")
                .attr('tabindex', '0');
            $slickSlider.find('.noTabStopHere').attr('tabindex', '-1'); // where flagged as such, we don't want tab stops since it adds no use for keyboard users
            $slickSlider
                .find(".slick-slide.slick-cloned[aria-hidden='true'] iframe.youtubeVideoPlayer")
                .attr('tabindex', '-1');
        }, 2000);

        if (!!param.announceSlidesShownFor) {
            var span =
                "<span class='" +
                param.sliderIdClass +
                "-liveRegion hiddenIR' aria-live='polite' aria-atomic='true'></span>";
            $slickSlider.after(span);
            announceSlides(slick); // set active liveRegion so screen readers can announce which slides are showing
        }

        if (!param.infinite) {
            if (!param.circularSlider) {
                $(param.prevArrowSelector).hasClass('slick-disabled')
                    ? $(param.prevArrowSelector).attr('disabled', 'disabled')
                    : $(param.prevArrowSelector).removeAttr('disabled');
                $(param.nextArrowSelector).hasClass('slick-disabled')
                    ? $(param.nextArrowSelector).attr('disabled', 'disabled')
                    : $(param.nextArrowSelector).removeAttr('disabled');
            } else {
                $(param.prevArrowSelector).attr('aria-disabled', 'false'); // if it is a circular slide, the arrows are always enabled with aria-disabled set to false.
                $(param.nextArrowSelector).attr('aria-disabled', 'false');
            }
        }

        if (param.slideAnimation) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    // If the element is visible
                    if (entry.isIntersecting) {
                        // Add the animation class to the slick track
                        $slickSlider.find('.slick-track').addClass('slide-animation');
                    }
                });
            });
            // observe the slider container for being in view
            observer.observe($slickSlider[0]);
        }

        // Deferred setPosition only for ondemand lazy-load sliders (floorplan/amenity photos, VC popup). Appointment time scrollers use lazyLoad progressive and rely on setSlickSliderSize / resize instead.
        if (param.lazyLoad === 'ondemand') {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    if ($slickSlider[0] && $slickSlider[0].slick) {
                        $slickSlider.slick('setPosition');
                    }
                });
            });
        }
    });

    var slickOptions = param;

    if (param.responsive_3_SlideSlider) {
        slickOptions = $.extend(slickOptions, {
            infinite: true, // for slick to show the correct # dots, and the reversing "circular" scrolling past end action pattern, per rentvision design, must set infinite=true
            slidesToShow: 1,
            mobileFirst: true,
            respondTo: 'slider',
            swipe: false,
            responsive: [
                {
                    breakpoint: 386,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 772,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    // don't really ever need this 4th breakpoint, but it is required to handle corner case for scrolling left from 1st slide, and scrolling right from last slide to get the visual full window sliding effect instead of the infinite scroller effect
                    breakpoint: 1158,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        });
    }

    $(slickSlider).slick(slickOptions);

    if (!!param.mouseWheelScrolling) {
        $(slickSlider).on('wheel', function (e) {
            e.preventDefault();
            if (e.originalEvent.deltaY < 0) {
                $(this).slick('slickPrev');
            } else {
                $(this).slick('slickNext');
            }
        });
    }

    //  lazy load the photo images 3 slides to the right and 3 slides to the left (and their clones (if slider is infinite)
    $slickSlider.on('beforeChange', function (event, slick) {
        if (!!param.beforeChangeCallback) {
            param.beforeChangeCallback(event, slick);
        }
        if (param.lazyLoad === 'ondemand' && param.ondemandPlus2 && slick.slideCount > 0) {
            var slidesToLazyLoadArray = [
                (slick.currentSlide + slick.slideCount + 3) % slick.slideCount,
                (slick.currentSlide + slick.slideCount - 2) % slick.slideCount,
            ];
            if (param.infinite) {
                var clonedSlides = [].concat(
                    slidesToLazyLoadArray.map(function (a) {
                        return a + slick.slideCount;
                    }),
                    ['-1'],
                );
                slidesToLazyLoadArray = [].concat(slidesToLazyLoadArray, clonedSlides);
            }
            slidesToLazyLoadArray.forEach(function (index) {
                var slideToLazyLoad = $(
                    slickSlider + ' .slick-slide[data-slick-index=' + index + '] img.slick-loading',
                );
                if (slideToLazyLoad.length > 0) {
                    var src = slideToLazyLoad.attr('src');
                    if (typeof src === 'undefined' || src === false) {
                        if (
                            slideToLazyLoad.hasClass('slider-full-image') ||
                            slideToLazyLoad.hasClass('object-fit-cover') ||
                            slideToLazyLoad.hasClass('object-fit-contain')
                        ) {
                            // do after-image-loaded actions when 1) swapping low res images out or 2) doing workaround of ie/edge non-support of object-fit: cover
                            slideToLazyLoad[0].addEventListener('load', slideImageLoaded);
                        }
                        slideToLazyLoad
                            .attr('src', slideToLazyLoad.attr('data-lazy'))
                            .removeClass('slick-loading')
                            .removeAttr('data-lazy');
                        if (slideToLazyLoad[0].complete && slideToLazyLoad[0].naturalWidth > 0) {
                            slideImageLoaded.call(slideToLazyLoad[0]);
                        }
                    } else {
                        // Slick (or a prior pass) already set src — still need loaded class for blur removal.
                        if (slideToLazyLoad[0].complete && slideToLazyLoad[0].naturalWidth > 0) {
                            slideImageLoaded.call(slideToLazyLoad[0]);
                        } else if (
                            slideToLazyLoad.hasClass('slider-full-image') ||
                            slideToLazyLoad.hasClass('object-fit-cover') ||
                            slideToLazyLoad.hasClass('object-fit-contain')
                        ) {
                            slideToLazyLoad[0].addEventListener('load', slideImageLoaded);
                        }
                    }
                }
            });
        }
    });

    // Slick's native ondemand lazy-load often sets src without our custom path; clear blur when it finishes.
    $slickSlider.on('lazyLoaded', function (event, slick, image) {
        const img = image && image[0] ? image[0] : image;
        if (img) {
            slideImageLoaded.call(img);
        }
    });

    $slickSlider.on('afterChange', function (event, slick) {
        // If the active slide was lazy-loaded outside our load listener, clear blur now.
        $slickSlider
            .find(
                '.slick-slide.slick-active img.slider-full-image, .slick-slide.slick-active img.object-fit-cover, .slick-slide.slick-active img.object-fit-contain',
            )
            .each(function () {
                const bg = this.parentElement && this.parentElement.parentElement;
                if (bg && bg.classList.contains('loaded')) {
                    return;
                }
                if (this.complete && this.naturalWidth > 0) {
                    slideImageLoaded.call(this);
                } else {
                    this.addEventListener('load', slideImageLoaded);
                }
            });
        if (!!param.afterChangeCallback) {
            param.afterChangeCallback(event, slick);
        }
        if (!param.infinite) {
            if (!param.circularSlider) {
                $(param.prevArrowSelector).hasClass('slick-disabled')
                    ? $(param.prevArrowSelector).attr('disabled', 'disabled')
                    : $(param.prevArrowSelector).removeAttr('disabled');
                $(param.nextArrowSelector).hasClass('slick-disabled')
                    ? $(param.nextArrowSelector).attr('disabled', 'disabled')
                    : $(param.nextArrowSelector).removeAttr('disabled');
            } else {
                $(param.prevArrowSelector).attr('aria-disabled', 'false'); // if it is a circular slide, the arrows are always enabled with aria-disabled set to false.
                $(param.nextArrowSelector).attr('aria-disabled', 'false');
            }
        }
        if (param.responsive_3_SlideSlider) {
            activateShownSlideDots(slickSlider);
        }
        $slickSlider
            .find(".floorplanSliderVideoContainer[aria-hidden='true'] .floorplanVideoPlayerContainer")
            .css('visibility', 'hidden'); // Wistia and YouTube video players contain multiple focusable/tabbable elements.
        $slickSlider
            .find(".floorplanSliderVideoContainer[aria-hidden='false'] .floorplanVideoPlayerContainer")
            .css('visibility', 'visible'); // Must toggle container visibility setting to ensure that such elements are appropriately tabbable/focusable after aria-hidden is toggled by Slick
        setTimeout(function () {
            // Override Slick bug, which is not setting tabindex correctly on slide when aria-hidden = true, so that we can tab to this visible slide
            $slickSlider.find(".slick-slide[aria-hidden='true'] button").attr('disabled', 'disabled');
            $slickSlider.find(".slick-slide[aria-hidden='true'] [tabindex='0']").attr('tabindex', '-1');
            $slickSlider.find(".slick-slide:not(.slick-cloned)[aria-hidden='false'] button").removeAttr('disabled');
            $slickSlider
                .find(".slick-slide:not(.slick-cloned)[aria-hidden='false'] :not(.noTabStopHere)[tabindex='-1']")
                .attr('tabindex', '0');
            $slickSlider.find('.noTabStopHere').attr('tabindex', '-1'); // where flagged as such, we don't want tab stops since it adds no use for keyboard users
            $slickSlider
                .find(".slick-slide.slick-cloned[aria-hidden='true'] iframe.youtubeVideoPlayer")
                .attr('tabindex', '-1');
        }, 100);
        if (!!param.announceSlidesShownFor) {
            // set active liveRegion so screen readers can announce which slides are showing
            announceSlides(slick);
        }
    });

    $slickSlider.on('breakpoint', function (event, slick) {
        if (!!param.breakpointCallback) {
            param.breakpointCallback(event, slick);
        }
        if (param.dots) {
            processDots(slick, slickSlider);
        }
    });

    $slickSlider.on('swipe', function () {
        if (!!param.swipeCallback) {
            param.swipeCallback();
        }
    });

    function processDots(slick, slickSlider) {
        if ($(slickSlider + ' .slick-dots li').length <= 1) {
            // if there is only 1 or less dots, then no need to display it.
            $(slickSlider + ' .slick-dots').hide();
        } else {
            $(slickSlider + ' .slick-dots').show();
            $(slickSlider + ' .slick-dots').attr('aria-label', 'Choose slide to display'); // insert aria-label on tablist (again).  Slick rewrites on each breakpoint.
            var $dots = $(slickSlider + ' .slick-dots button');
            $dots.keydown(function (event) {
                scrollerKeyHandler(event, slickSlider);
            });
            removeAriaDescribedbyIfBad(slickSlider); // Must remove aria-labelledby references (Slick had created) which point to no elements, since Slick also removes tablist when all slides can be shown and no scrolling is necessary
            if (param.responsive_3_SlideSlider) {
                var slideCount = slick.slideCount;
                var slidesShowing = $(
                    slickSlider + " :not('.slick-dots') .slick-slide.slick-active:not('.slick-cloned')",
                ).length;
                if (slideCount > slidesShowing) {
                    // if clicking on either of the last dot or two, slide the scroller so that the last slide is in the rightmost visible slide position
                    if (slidesShowing >= 2) {
                        $($dots[$dots.length - 1]).on('click', function (event) {
                            slideScrollerToLastPosition();
                            event.preventDefault();
                            return false;
                        });
                    }
                    if (slidesShowing >= 3) {
                        $($dots[$dots.length - 2]).on('click', function (event) {
                            slideScrollerToLastPosition();
                            event.preventDefault();
                            return false;
                        });
                    }
                    activateShownSlideDots(slickSlider);
                }
            }
            setTimeout(function () {
                // Override Slick bug, which sets aria-label incorrectly when only 2 of 3 slides showing
                $(slickSlider + ' .slick-dots button[aria-label]').attr('aria-label', function (index) {
                    // Short timer required to set aria-label after Slick sets it
                    return index + 1 + ' of ' + slick.slideCount + ' slides';
                });
            }, 1000);
        }
    }

    function activateShownSlideDots(slickSlider) {
        // highlight dots corresponding to the slides that are visible, slick only highlights the one dot corresponding to just the first active slide
        $(slickSlider + ' .slick-dots li').removeClass('slick-slide-is-active');
        $(slickSlider + " .slick-slide.slick-active:not('.slick-cloned')").each(function (index, slide) {
            var dotId = slide.getAttribute('aria-describedby');
            var dotElement = document.getElementById(dotId);
            if (dotElement) {
                dotElement.parentNode.classList.add('slick-slide-is-active');
            }
        });
    }

    function announceSlides(slick) {
        var slideCount = slick.slideCount;
        var $activeSlides = $slickSlider.find(" :not('.slick-dots') .slick-slide.slick-active:not('.slick-cloned')");
        var slidesShowing = $activeSlides.length;
        var announcement = '';
        if (slideCount > slidesShowing) {
            switch (slidesShowing) {
                case 1:
                    announcement =
                        'Showing slide ' +
                        (parseInt($activeSlides[0].dataset.slickIndex) + 1).toString() +
                        ' of ' +
                        slideCount.toString() +
                        ' ' +
                        param.announceSlidesShownFor;
                    break;
                case 2:
                    announcement =
                        'Showing slides ' +
                        (parseInt($activeSlides[0].dataset.slickIndex) + 1).toString() +
                        ' and ' +
                        (parseInt($activeSlides[1].dataset.slickIndex) + 1).toString() +
                        ' of ' +
                        slideCount.toString() +
                        ' ' +
                        param.announceSlidesShownFor;
                    break;
                case 3:
                    announcement =
                        'Showing slides ' +
                        (parseInt($activeSlides[0].dataset.slickIndex) + 1).toString() +
                        ', ' +
                        (parseInt($activeSlides[1].dataset.slickIndex) + 1).toString() +
                        ', and ' +
                        (parseInt($activeSlides[2].dataset.slickIndex) + 1).toString() +
                        ' of ' +
                        slideCount.toString() +
                        ' ' +
                        param.announceSlidesShownFor;
                    break;
            }
            $(slickSlider + '-liveRegion').text(announcement);
        }
    }

    function slideImageLoaded() {
        // things to do only after the slider-full-image has loaded
        this.parentElement.parentElement.classList.add('loaded');
        if ((isEdge() || isIE()) && $(this).hasClass('object-fit-cover')) {
            // workaround for ie and edge which do not support object-fit: cover
            this.parentElement.parentElement.style.backgroundImage = 'url(' + this.src + ')';
            this.parentElement.parentElement.classList.add('ie-edge-workaround-for-object-fit-cover');
        } else if (isIE() && $(this).hasClass('object-fit-contain')) {
            // workaround for ie which does not support object-fit: contain
            this.parentElement.parentElement.style.backgroundImage = 'url(' + this.src + ')';
            this.parentElement.parentElement.classList.add('ie-workaround-for-object-fit-contain');
        }
        $(this).parent().parent().parent().find('.loading-animation').remove();

        var $sliderEl = $(this).closest('.slick-slider');
        if ($sliderEl.length && $sliderEl.get(0).slick) {
            requestAnimationFrame(function () {
                $sliderEl.slick('setPosition');
            });
        }
    }

    return returnedSlider;
}

function loadImgGalleryPopup(imgGalleryPopupId) {
    $(`.${imgGalleryPopupId}-trigger`).magnificPopup({
        type: 'inline',
        preloader: false,
        callbacks: {
            beforeOpen: function () {
                this.st.mainClass = this.st.el.attr('mfp-zoom-in');

                // Set the src attribute of each img to the value of its data-lazy-event attribute
                populateImgGallerySRCs(imgGalleryPopupId); //load all
                populateImgGalleryInfo(imgGalleryPopupId);
            },
            open: function () {
                // Disable scrolling of background html element
                $('html').css('overflow', 'hidden');

                setTimeout(() => {
                    $(`#${imgGalleryPopupId} .loading-animation`).hide();
                }, 1000);

                //scroll the image the user was on in the embeded slider into view
                scrollImgFromSliderIntoView();
            },
            close: function () {
                // Enable scrolling on html (normal page)
                $('html').css('overflow', '');
            },
        },
    });
}

function populateImgGallerySRCs(imgGalleryPopupId, numToLoad = Infinity) {
    // Set the src attribute of each img to the value of its data-lazy-event attribute
    $(`#${imgGalleryPopupId} img`).each(function (currentIndex) {
        if (currentIndex === 0) {
            $(this).removeAttr('loading'); //first images no lazy
        }
        if (currentIndex > numToLoad) return;
        const lazySrc = $(this).attr('data-lazy-event');
        $(this).attr('src', lazySrc);
        $(this).removeAttr('data-lazy-event');
    });
}

function populateImgGalleryInfo(imgGalleryPopupId) {
    const images = $(`#${imgGalleryPopupId} img`);
    const numberCaptions = $(`#${imgGalleryPopupId} .gallery-img-caption-num`);

    const total = images.length;

    images.each(function (index) {
        // Add the data-index attribute to each image
        $(this).attr('data-index', index);
    });

    numberCaptions.each(function (index) {
        $(this).text(`${index + 1} of ${total}`);
    });
}

function scrollImgFromSliderIntoView() {
    // Get the currently active image in the slick slider
    const currentImage = $('.slick-current img').attr('id');

    // Scroll the target image into view after a short delay
    if (currentImage?.length) {
        // Find the corresponding image in the fullscreen gallery
        const targetImage = currentImage.replace('carouselFeature', 'gallery');
        setTimeout(function () {
            document.getElementById(targetImage)?.scrollIntoView?.({ behavior: 'smooth' });
        }, 300);
    }
}

function scrollImgByIndexIntoView(imgGalleryPopupId, index) {
    // Find the image with the specified data-index attribute
    const targetImg = $(`#${imgGalleryPopupId} img[data-index="${index}"]`);

    if (targetImg.length) {
        setTimeout(function () {
            targetImg[0].scrollIntoView({ behavior: 'smooth' });
        }, 500);
    }
}
